'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _select = require('select2');

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

if ((0, _jquery2.default)('.shop-look__deal').length > 0) {
  (0, _jquery2.default)('.shop-look__slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 1280,
      settings: {
        arrows: false
      }
    }, {
      breakpoint: 1200,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
}

if ((0, _jquery2.default)('.product__images').length > 0) {
  (0, _jquery2.default)('.product__images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    mobileFirst: true,
    responsive: [{
      breakpoint: 900,
      settings: 'unslick'
    }]
  });
}

/*!
 * Accordion
 */
(0, _jquery2.default)('.accordion__title').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)(this).parent().toggleClass('active');
});

/*!
 * Product
 */
(0, _jquery2.default)('.product__thumbnails').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infitite: true,
  centerMode: true
});
(0, _jquery2.default)(document).on('click', '.product__thumb-toggle', function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.product__thumbnails').addClass('active');
});
(0, _jquery2.default)(document).on('click', '.product__thumbnails li, .product__pagination li', function (e) {
  e.preventDefault();
  var index = (0, _jquery2.default)(this).attr('data-id');
  (0, _jquery2.default)('.product__thumbnails').removeClass('active');
  (0, _jquery2.default)('body, html').animate({ scrollTop: (0, _jquery2.default)('.product__image[data-id="' + index + '"]').offset().top - 73 });
});
var lastScrollTop = 0;
var ww = (0, _jquery2.default)(window).width();
(0, _jquery2.default)(window).on('scroll', function () {
  var st = (0, _jquery2.default)(this).scrollTop();
  if (ww > 900) {
    (0, _jquery2.default)('.product__image').each(function (i) {
      var index = i + 1;
      if (st >= (0, _jquery2.default)('.product__image[data-id="' + index + '"]').offset().top - 74) {
        (0, _jquery2.default)('.product__pagination li').removeClass('active');
        (0, _jquery2.default)('.product__pagination li[data-id="' + index + '"]').addClass('active');
      }
    });
    lastScrollTop = st;
  }
});

if ((0, _jquery2.default)('.featured-season__slider').length > 0) {
  (0, _jquery2.default)('.featured-season__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false
  });
}

/*!
 * Global
 */

// Hamburger Menu
(0, _jquery2.default)(document).on('click', '.hamburger', function () {
  (0, _jquery2.default)('.hamburger, .off-canvas, .header').toggleClass('active');
});

(0, _jquery2.default)('.header__search').click(function () {
  (0, _jquery2.default)('.search-dropdown').toggleClass('active');
  setTimeout(function () {
    (0, _jquery2.default)('.off-canvas input[type="search"]').focus();
  }, 100);
});

(0, _jquery2.default)('.image-callout__video-toggle').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.image-callout__video-wrapper iframe')[0].src += "?autoplay=1";
  (0, _jquery2.default)('.image-callout__video-wrapper, .image-callout__right img').addClass('active');
});

// Stockists Page
(0, _jquery2.default)('.stockists__sidebar li a').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, 0);
  (0, _jquery2.default)('.stockists__sidebar li a').removeClass('active');
  (0, _jquery2.default)(this).addClass('active');
  var stockistState = (0, _jquery2.default)(this).attr('data-stockist');
  if (stockistState == 'all') {
    (0, _jquery2.default)('.stockists__block').show();
  } else {
    (0, _jquery2.default)('.stockists__block').hide();
    (0, _jquery2.default)('.stockists__block[data-stockist="' + stockistState + '"]').show();
  }
});

// Shop Menu Item
(0, _jquery2.default)(document).on('click', '.shop-menu a, .dropdown__close', function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.dropdown, .shop-menu').toggleClass('active');
});

(0, _jquery2.default)('.popup__close').click(function (e) {
  e.preventDefault();
  localStorage.setItem('popup', 1);
  (0, _jquery2.default)('.popup').removeClass('active');
});

var popup = localStorage.getItem('popup');

if (popup === null) {
  setTimeout(function () {
    (0, _jquery2.default)('.newsletter-popup').addClass('active');
    popup = true;
  }, 7000);
}

(0, _jquery2.default)('.footer__subscribe-link').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.newsletter-popup').addClass('active');
});

if ((0, _jquery2.default)('.collections__dropdowns #sort-by').length) {
  (0, _jquery2.default)('.collections__dropdowns #sort-by').select2({
    minimumResultsForSearch: Infinity,
    placeholder: 'Sort By'
  }).on('change', function (event) {
    if ((0, _jquery2.default)('#sort-by').val() == '') return;
    Shopify.queryParams.sort_by = (0, _jquery2.default)('#sort-by').val();
    location.search = _jquery2.default.param(Shopify.queryParams).replace(/\+/g, '%20');
  });
}

if ((0, _jquery2.default)('.collections__dropdowns #filter-by').length) {
  (0, _jquery2.default)('.collections__dropdowns #filter-by').select2({
    minimumResultsForSearch: Infinity,
    placeholder: 'Filter'
  }).on('change', function (event) {
    if ((0, _jquery2.default)('#filter-by').val() == '') return;
    window.location = (0, _jquery2.default)('#filter-by').val();
  });
}

/*!
 * Newsletter
 */
(0, _jquery2.default)('.newsletter-popup__close').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.newsletter-popup').removeClass('active');
  localStorage.setItem('popup', 1);
});

// Off Canvas Dropdown
(0, _jquery2.default)('.off-canvas__menu .has-children > a').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)(this).parent().toggleClass('active');
});

// Shop Menu Rollover Images
(0, _jquery2.default)(document).on('mouseenter', '.dropdown__menu li a', function (e) {
  e.preventDefault();
  var imageAttr = (0, _jquery2.default)(this).data('image');
  var image = (0, _jquery2.default)('.dropdown__image img[data-image="' + imageAttr + '"]');
  if (image.length > 0) {
    (0, _jquery2.default)('.dropdown__image img').removeClass('active');
    (0, _jquery2.default)(image).addClass('active');
  }
});

// Size Guide Dropdown
(0, _jquery2.default)(document).on('click', '.product__size-guide-trigger, .size-guide__close', function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.size-guide, .header').toggleClass('active');
});

// Subscribe Close
(0, _jquery2.default)('.featured-season__subscribe-close').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.featured-season__subscribe').fadeOut();
});

// Add border-bottom on header if window has scrolled down
(0, _jquery2.default)(window).on('scroll', function () {
  var st = (0, _jquery2.default)(window).scrollTop();
  if (st > 50) {
    (0, _jquery2.default)('.header, .search, .dropdown, .size-guide').addClass('scrolled');
  } else {
    (0, _jquery2.default)('.header, .search, .dropdown, .size-guide').removeClass('scrolled');
  }
});

// Local Storage for the 2 / 4 columns selector in collections
var columns = localStorage.getItem('columns');
if (columns === '2') {
  (0, _jquery2.default)('.collections__items').addClass('two-cols');
  (0, _jquery2.default)('.collections__view a[data-cols="2"]').addClass('active');
} else {
  (0, _jquery2.default)('.collections__items').removeClass('two-cols');
  (0, _jquery2.default)('.collections__view a[data-cols="4"]').addClass('active');
}

// Set columns in localstoage
(0, _jquery2.default)(document).on('click', '.collections__view a', function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.collections__view a').removeClass('active');
  var cols = (0, _jquery2.default)(this).attr('data-cols');
  (0, _jquery2.default)('.collections__view a[data-cols="' + cols + '"]').addClass('active');
  localStorage.setItem('columns', cols);
  if (cols === '2') {
    (0, _jquery2.default)('.collections__items').addClass('two-cols');
  } else {
    (0, _jquery2.default)('.collections__items').removeClass('two-cols');
  }
});

(0, _jquery2.default)('.back-in-stock__close').click(function (e) {
  e.preventDefault();
  (0, _jquery2.default)('.back-in-stock').removeClass('active');
});

var notificationCallback = function notificationCallback(data) {
  var msg = '';
  if (data.status == 'OK') {
    msg = data.message; // just show the success message
  } else {
    // it was an error
    msg = 'Your email is already on the list for this size.';
  }
  (0, _jquery2.default)('.back-in-stock').append('<p>' + msg + '</p>');
  setTimeout(function () {
    (0, _jquery2.default)('.back-in-stock').removeClass('active');
    (0, _jquery2.default)('.back-in-stock p').remove();
  }, 2000);
};
(0, _jquery2.default)('#notify_button').click(function (e) {
  e.preventDefault();
  var email = (0, _jquery2.default)('#notify_email').val(),
      productId = (0, _jquery2.default)(this).attr('data-product-id'),
      // rendered by Liquid
  variantId = (0, _jquery2.default)(this).attr('data-variant-id'); // rendered by Liquid
  BIS.create(email, variantId, productId).then(notificationCallback);
});

(0, _jquery2.default)(function () {
  var hash = window.location.hash.replace('#', '');
  if (hash === 'sustainable' && (0, _jquery2.default)('body').hasClass('template-index')) {
    setTimeout(function () {
      (0, _jquery2.default)('html, body').animate({ scrollTop: (0, _jquery2.default)('#sustain').offset().top }, 500);
      (0, _jquery2.default)('.image-callout__video-wrapper iframe')[0].src += "?autoplay=1";
      (0, _jquery2.default)('.image-callout__video-wrapper, .image-callout__right img').addClass('active');
    }, 500);
  }
});